import { render, staticRenderFns } from "./FileUploadTile.vue?vue&type=template&id=6093608b&scoped=true&"
import script from "./FileUploadTile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FileUploadTile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FileUploadTile.vue?vue&type=style&index=0&id=6093608b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093608b",
  null
  
)

export default component.exports